

import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { css } from '@emotion/react';
import { ClipLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';
import { Pie, Bar } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';
import JobSeekerTable from './JobseekersTable';
import EmployerTable from './EmployersTable';
import ApplicationTable from './Application';
import JobStatistics from './JobStatistics';
import NonRegisteredUser from './NonRegisteredUser';
import SuperAdminManage from './SuperAdminManage';
import SuperAdminJobPlans from './SuperAdminJobPlans';
import SuperAdminEmployerEmployee from './SuperAdminEmployerEmployee';
import Benefit from './Benefit';
import EmployeeTaxHistory from './EmployeeTaxHistory';
import JobSeekerDetails from '../component/Modals/JobSeekerDetails';
import SuperAdminJobSeekerDetails from './SuperAdminJobSeekerDetails';
import SuperAdminBenefit from './SuperAdminBenefit';
import BenefitOverview from './BenefitOverview';
import SuperAdminJobApproval from './SuperAdminApproval';
import PremiumJobs from './PremiumJobs';
import UrgentStaff from "./UrgentRequestSuperAdmin"
import CertifyJobSeekers from './CertifyJobSeekers';
import JobSeekerStatistics from './JobSeekerStatistics';
import JobListing from './JobListing';
import JobApplicationButton from '../pages/Profile/JobApplicationButton';
import JobApplicationFormShareable from './JobApplicationFormSharable';
import FormAnalytics from './JobApplicationFormAnalytics';
import JobEmployerList from './ApproveEmployers';
import JobPostForm from './postJob';
import VideoManager from './PostVideo';
import CreateAdminForm from '../adminLatest/CreateAdmin';
import AllAdminsOverview from '../adminLatest/SuperAdminOverview';
import MarketersLocationStats from '../adminLatest/MarketersPerformance';
import  AdminFilteredSystem  from './AdminFilteredSystem';
import {  useSearchParams } from 'react-router-dom'; 
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

const override = css`
  display: block;
  margin: 0 auto;
`;

const SidebarLink = ({ label, section, activeSection, setActiveSection }) => {
  const isActive = activeSection === section;

  return (
    <li>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setActiveSection(section);
        }}
        className={`flex items-center p-3 rounded-lg font-medium transition-all duration-200 ${
          isActive 
            ? 'bg-blue-600 text-white shadow-sm' 
            : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900'
        }`}
      >
        {label}
      </a>
    </li>
  );
};



// const Sidebar = ({ isOpen, toggleSidebar, setActiveSection }) => (
//   <div className={`fixed top-0 left-0 h-full bg-white shadow-lg transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:w-64 z-50`}>
//     <div className="p-4">
//       <button onClick={toggleSidebar} className="lg:hidden absolute top-4 right-4 text-gray-500 hover:text-gray-700">
//         <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
//         </svg>
//       </button>
//       <div className="flex items-center space-x-3 mb-6">
//         <h3>EJOBS</h3>
//         <div>
//           {/* <p className="text-sm font-semibold">Sarah Connor</p>
//           <p className="text-xs text-gray-500">sarah@digimax.com</p> */}
//         </div>
//       </div>
//       <nav className="overflow-y-auto max-h-[calc(100vh-120px)]"> {/* Scrollable nav with max height */}
//         <ul className="space-y-2">
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('dashboard'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Dashboard</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('jobSeekers'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Job seekers</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('jobEmployers'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Job employers</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('jobApplications'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Job Applications</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('jobStatistics'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Job statistics</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('non-registered-users'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Registered-users</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('createAdmins'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Create Admins</a></li>
//           {/* <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('jobPlans'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Job Plans</a></li> */}
//            <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('postjob'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Post a job</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('approveJobs'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Approve Jobs</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('approvejobEmployersDetails'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Approve employers location</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('premiumJobs'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Premium Jobs</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('employeremployee'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Employer-Employee</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('benefit'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Benefit</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('urgentStaff'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Urgent Staff</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('createNewAdmin'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Create new Admin</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('seeAdminsCreated'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">See created Admins</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('marketersPerformance'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Marketers performance</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('certifyJobSeekers'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Certify Jobseekers</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('jobSeekerStatistics'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Jobseekers stats</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('filter'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Filter System</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('taxHistory'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Tax history</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('jobSeekerDetails'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Job seeker Details</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('businessTypes'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Business types</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('jobListings'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Job Listing</a></li>
//           <li><a href="#" onClick={(e) => { e.preventDefault(); setActiveSection('postVideos'); }} className="flex items-center p-2 text-gray-700 hover:bg-gray-100 rounded">Post videos</a></li>

//         </ul>
//       </nav>
//     </div>
//   </div>
// );


const Sidebar = ({ isOpen, toggleSidebar, setActiveSection, activeSection }) => (
  <div className={`fixed top-0 left-0 h-full bg-white shadow-lg transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:w-64 z-50`}>
    <div className="p-4">
      <button onClick={toggleSidebar} className="lg:hidden absolute top-4 right-4 text-gray-500 hover:text-gray-700">
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      <div className="flex items-center space-x-3 mb-8">
        <h3 className="text-2xl font-bold text-blue-700">EJOBS</h3>
      </div>

      <nav className="overflow-y-auto max-h-[calc(100vh-120px)]">
        <ul className="space-y-1">
          <SidebarLink 
            label="Dashboard" 
            section="dashboard" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Job Seekers" 
            section="jobSeekers" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Job Employers" 
            section="jobEmployers" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Job Applications" 
            section="jobApplications" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Job Statistics" 
            section="jobStatistics" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Registered Users" 
            section="non-registered-users" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Post a Job" 
            section="postjob" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Approve Jobs" 
            section="approveJobs" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Approve Employers Location" 
            section="approvejobEmployersDetails" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Premium Jobs" 
            section="premiumJobs" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          {/* <SidebarLink 
            label="Employer-Employee" 
            section="employeremployee" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          /> */}
          <SidebarLink 
            label="Benefit" 
            section="benefit" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          {/* <SidebarLink 
            label="Urgent Staff" 
            section="urgentStaff" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          /> */}
          <SidebarLink 
            label="Create New Admin" 
            section="createNewAdmin" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="See Created Admins" 
            section="seeAdminsCreated" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Marketers Performance" 
            section="marketersPerformance" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Certify Jobseekers" 
            section="certifyJobSeekers" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Jobseekers Stats" 
            section="jobSeekerStatistics" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Filter System" 
            section="filter" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Tax History" 
            section="taxHistory" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Job Seeker Details" 
            section="jobSeekerDetails" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Job Listing" 
            section="jobListings" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
          <SidebarLink 
            label="Post Videos" 
            section="postVideos" 
            activeSection={activeSection} 
            setActiveSection={setActiveSection} 
          />
        </ul>
      </nav>
    </div>
  </div>
);
const ProjectCard = ({ title, color, progress, value }) => (
  <div className={`p-4 rounded-lg ${color} text-white`}>
    <h3 className="text-lg font-semibold">{title}</h3>
    <div className="w-full bg-gray-200 rounded-full h-2.5 mt-2">
      <div className="bg-white h-2.5 rounded-full" style={{ width: `${progress}%` }}></div>
    </div>
    <p className="mt-2 text-sm">{value}</p>
  </div>
);

const Task = ({ time, title, color }) => (
  <div className="flex items-center justify-between py-2">
    <span className="text-sm">{time}</span>
    <span className={`px-2 py-1 text-xs rounded ${color}`}>{title}</span>
  </div>
);

const Admin = ({ onClick }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);

    const [showForm, setShowForm] = useState(false);


  const [jobs, setJobs] = useState([]);
  const [jobSeekers, setJobSeekers] = useState([]);
  const [employers, setEmployers] = useState([]);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();   // ← New

  // Get active section from URL or default to dashboard
  const activeSection = searchParams.get('section') || 'dashboard';

  // Update URL when activeSection changes
  const setActiveSection = (section) => {
    setSearchParams({ section });
  };


  useEffect(() => {
    const token = localStorage.getItem('adminToken')
    if(!token){
          toast.error('Please log in to access the dashboard');
      navigate('/');
      return;
    }
  })

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('Please log in to access the dashboard');
      navigate('/');
      return;
    }
    console.log(token, "my token")

    const fetchDashboardData = async () => {
      try {
        // Fetch user/dashboard data
        const dashboardResponse = await fetch(`${process.env.REACT_APP_API_URL}admin/dashboard`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` },
        });
        const dashboardData = await dashboardResponse.json();
        console.log('Dashboard Response:', dashboardData);
        setUser(dashboardData.user || dashboardData);
      

        // Fetch jobs data
        const jobsResponse = await fetch(`${process.env.REACT_APP_BASE_URL || 'http://localhost:3008/api/v1/'}job/allJob?page=1&limit=100`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` },
        });
        const jobsData = await jobsResponse.json();
        console.log('Jobs Response:', jobsData);
        if (jobsResponse.ok) {
          setJobs(jobsData.data || jobsData); // Flexible parsing
        } else {
          toast.error(jobsData.message || 'Failed to fetch jobs');
        }

        // Fetch job seekers data
        const jobSeekersResponse = await fetch(`${process.env.REACT_APP_BASE_URL || 'http://localhost:3008/api/v1/'}jobseeker/allJobSeeker`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` },
        });
        const jobSeekersData = await jobSeekersResponse.json();
        console.log('Job Seekers Response:', jobSeekersData);
        if (jobSeekersResponse.ok) {
          setJobSeekers(jobSeekersData.data || jobSeekersData);
        } else {
          toast.error(jobSeekersData.message || 'Failed to fetch job seekers');
        }

        // Fetch employers data
        const employersResponse = await fetch(`${process.env.REACT_APP_BASE_URL || 'http://localhost:3008/api/v1/'}jobrecruiter/allJobEmployer`, {
          method: 'GET',
          headers: { 'Authorization': `Bearer ${token}` },
        });
        const employersData = await employersResponse.json();
        console.log('Employers Response:', employersData);
        if (employersResponse.ok) {
          setEmployers(employersData.data || employersData);
        } else {
          toast.error(employersData.message || 'Failed to fetch employers');
        }
      } catch (error) {
        console.error('Dashboard Error:', error);
        // toast.error('An error occurred while loading the dashboard');
        if (error.message.includes('401')) {
          localStorage.removeItem('token');
          navigate('/');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [navigate]);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <ClipLoader color="#000000" css={override} size={50} />
      </div>
    );
  }

  if (!user) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-100">
        <h2>Unauthorized. Please log in.</h2>
      </div>
    );
  }

  // Process data for charts and cards
  const processMonthlyRegistrations = (users) => {
    const monthlyData = {};
    users.forEach(user => {
      if (user.createdAt) {
        const month = new Date(user.createdAt).toLocaleString('default', { month: 'long', year: 'numeric' });
        monthlyData[month] = (monthlyData[month] || 0) + 1;
      }
    });
    return {
      labels: Object.keys(monthlyData),
      datasets: [{
        label: 'Registrations',
        data: Object.values(monthlyData),
        backgroundColor: 'rgba(75, 192, 192, 0.2)',
        borderColor: 'rgba(75, 192, 192, 1)',
        borderWidth: 1,
      }],
    };
  };

  const processStateRegistrations = (users) => {
    const stateData = {};
    users.forEach(user => {
      if (user.state) {
        stateData[user.state] = (stateData[user.state] || 0) + 1;
      }
    });
    return {
      labels: Object.keys(stateData),
      datasets: [{
        label: 'Registrations by State',
        data: Object.values(stateData),
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF'],
        hoverOffset: 4,
      }],
    };
  };

  const processApplicantsByIndustry = () => {
    const industryData = {};
    jobs.forEach(job => {
      const industry = job.industry || 'Unknown';
      const applicants = job.applications?.length || 0;
      industryData[industry] = (industryData[industry] || 0) + applicants;
    });
    return {
      labels: Object.keys(industryData),
      datasets: [{
        label: 'Applicants by Industry',
        data: Object.values(industryData),
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF'],
        hoverOffset: 4,
      }],
    };
  };

  const jobSeekersMonthlyData = processMonthlyRegistrations(jobSeekers);
  const employersMonthlyData = processMonthlyRegistrations(employers);
  const jobSeekersStateData = processStateRegistrations(jobSeekers);
  const employersStateData = processStateRegistrations(employers);
  const applicantsByIndustryData = processApplicantsByIndustry();

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
    },
  };

  // Define content for each section
  const renderContent = () => {
    switch (activeSection) {
      case 'dashboard':
        return (
          <>
            <h1 className="text-2xl font-bold mb-6">Hello, {user.email || 'User'}</h1>



    {/* <div className=" bg-gray-100 p-8">
      <JobApplicationButton onClick={() => setShowForm(true)} />
      <FormAnalytics />
      {showForm && (
        <JobApplicationFormShareable onClose={() => setShowForm(false)} />
      )}
    </div>
 */}



   



            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              <ProjectCard title="Total Job Seekers" color="bg-purple-500" progress={70} value={jobSeekers.length} />
              <ProjectCard title="Total Employers" color="bg-teal-500" progress={40} value={employers.length} />
              <ProjectCard title="Total Jobs" color="bg-orange-500" progress={60} value={jobs.length} />
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-6">
              <div className="bg-white p-6 rounded-lg shadow">
                <h2 className="text-lg font-semibold mb-4">Job Seekers Registrations (Monthly)</h2>
                <Bar data={jobSeekersMonthlyData} options={chartOptions} />
              </div>
              <div className="bg-white p-6 rounded-lg shadow">
                <h2 className="text-lg font-semibold mb-4">Employers Registrations (Monthly)</h2>
                <Bar data={employersMonthlyData} options={chartOptions} />
              </div>
              <div className="bg-white p-6 rounded-lg shadow">
                <h2 className="text-lg font-semibold mb-4">Job Seekers by State</h2>
                <Pie data={jobSeekersStateData} options={chartOptions} />
              </div>
              <div className="bg-white p-6 rounded-lg shadow">
                <h2 className="text-lg font-semibold mb-4">Employers by State</h2>
                <Pie data={employersStateData} options={chartOptions} />
              </div>
              <div className="bg-white p-6 rounded-lg shadow lg:col-span-2">
                <h2 className="text-lg font-semibold mb-4">Applicants by Industry</h2>
                <Bar data={applicantsByIndustryData} options={chartOptions} />
              </div>
             

    <div className="">
      <button
        onClick={onClick}
        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg shadow-md transition duration-300"
      >
        Generate Job Application Form
      </button>
    </div>


            </div>
          </>
        );
      case 'jobSeekers':
        return (
          <div >
            <h1 className="text-2xl font-bold mb-6">Job Seekers</h1>
           <JobSeekerTable />
            {/* Add job seekers data or components here */}
          </div>
        );
      case 'jobEmployers':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Job Employers</h1>
            <EmployerTable />
          </div>
        );
      case 'jobApplications':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Job Application</h1>
            <ApplicationTable />
          </div>
        );
      case 'jobStatistics':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Job Statistics</h1>
            <JobStatistics />
          </div>
        );
      case 'non-registered-users':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Non Registered-users</h1>
            <NonRegisteredUser />
          </div>
        );
      case 'createAdmins':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Create Admins</h1>
            <SuperAdminManage />
          </div>
        );
      case 'jobPlans':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Job plans</h1>
            <SuperAdminJobPlans />
          </div>
        );
      case 'employeremployee':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Employer-employee</h1>
            <SuperAdminEmployerEmployee />
          </div>
        );
      case 'benefit':
        return (
          <div className="">
            <h1 className="text-2xl font-bold mb-6">Benefit</h1>
            <SuperAdminBenefit />
            {/* <BenefitOverview /> */}
          
          </div>
        );
      case 'urgentStaff':
        return (
          <div className="">
            <h1 className="text-2xl font-bold mb-6">Urgent staff</h1>
           <UrgentStaff />
          
          </div>
        );
      case 'createNewAdmin':
        return (
          <div className="">
            <h1 className="text-2xl font-bold mb-6">create new Admin</h1>
           <CreateAdminForm />
          
          </div>
        );
      case 'seeAdminsCreated':
        return (
          <div className="">
            <h1 className="text-2xl font-bold mb-6">See admins created</h1>
           <AllAdminsOverview />
          
          </div>
        );
      case 'certifyJobSeekers':
        return (
          <div className="">
            <h1 className="text-2xl font-bold mb-6">certify Jobseekers</h1>
           <CertifyJobSeekers />
          
          </div>
        );
      case 'jobSeekerStatistics':
        return (
          <div className="">
            <h1 className="text-2xl font-bold mb-6">jobSeeker statis</h1>
           <JobSeekerStatistics />
          
          </div>
        );
      case 'postjob':
        return (
          <div className="">
            <h1 className="text-2xl font-bold mb-6">post a job</h1>
           <JobPostForm />
          
          </div>
        );
      case 'approveJobs':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Approve jobs</h1>
            <SuperAdminJobApproval />
          </div>
        );
      case 'approvejobEmployersDetails':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Approve employers location</h1>
            <JobEmployerList />
          </div>
        );
      case 'premiumJobs':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Premium jobs</h1>
            <PremiumJobs />
          </div>
        );
      case 'filter':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Filter System</h1>
            <AdminFilteredSystem />
          </div>
        );
      case 'taxHistory':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Tax history</h1>
            <EmployeeTaxHistory />
          </div>
        );
      case 'jobSeekerDetails':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Job seeker Details</h1>
            <SuperAdminJobSeekerDetails/>
          </div>
        );
      case 'jobPlans':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Job Plans</h1>
            <SuperAdminJobPlans />
          </div>
        );
      case 'marketersPerformance':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">marketers Performance </h1>
            <MarketersLocationStats />
          </div>
        );
      case 'jobListings':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Job Listings</h1>
              <JobListing/>
          </div>
        );
      case 'businessTypes':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Business Types</h1>
       
            {/* Add business types data or components here */}
          </div>
        );
      case 'postVideos':
        return (
          <div className="p-6">
            <h1 className="text-2xl font-bold mb-6">Post Videos</h1>

           <VideoManager/>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar 
  isOpen={isSidebarOpen} 
  toggleSidebar={toggleSidebar} 
  setActiveSection={setActiveSection}
  activeSection={activeSection}   // ← Add this
/>
      {/* <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} setActiveSection={setActiveSection} /> */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <header className="bg-white shadow p-4 flex justify-between items-center lg:hidden">
          <button onClick={toggleSidebar} className="text-gray-500 hover:text-gray-700">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
          <button className="bg-black text-white px-4 py-2 rounded">Add New Project</button>
        </header>
        <main className="flex-1 overflow-y-auto p-6">
          {renderContent()}
        </main>
      </div>
    </div>
  );
};

export default Admin;


























































